import * as React from 'react';

class Dashboard extends React.PureComponent {
    public render(): JSX.Element {
        return <div />;
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/view/account/Dashboard.tsx